import { Permission } from '@dispatch/shared/types';
import { FormControlLabel, List, ListItem } from '@mui/material';
import React from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { UserForm } from '../details/UserDetails';
import { mapPermissionsToFriendlyName } from '@dispatch/shared';
import { UserPermissionCheckBox } from './UserPermissionCheckBox';

interface UserPermissionsProps {
  rolePermissions: Permission[];
  userPermissions: Record<string, Permission>;
  disabledPermissions: Record<string, Permission>;
  setUserPermissions: React.Dispatch<
    React.SetStateAction<Record<string, Permission>>
  >;
  setDisabledPermissions: React.Dispatch<
    React.SetStateAction<Record<string, Permission>>
  >;
  setValue: UseFormSetValue<UserForm>;
  disabledIds: string[];
}

export const UserPermissions = ({
  rolePermissions,
  ...rest
}: UserPermissionsProps) => {
  return (
    <List sx={{ padding: '0 0 0 0.625rem' }}>
      {rolePermissions?.map((permission: Permission, index: number) => {
        return (
          <ListItem key={`${permission?.operationId}_${index}`} disablePadding>
            <FormControlLabel
              control={
                <UserPermissionCheckBox {...rest} permission={permission} />
              }
              label={mapPermissionsToFriendlyName(permission?.operationId)}
            />
          </ListItem>
        );
      })}
    </List>
  );
};
